import {confidenceLevel, ConfidenceLevel} from "./TradingIdeasConfidenceLevel";

export class TradingIdeasConfidenceViewModel {

    private constructor(public readonly confidence: number, public readonly level: ConfidenceLevel) {

    }

    public static create(confidence: number) {
        const level = confidenceLevel(confidence);
        return new TradingIdeasConfidenceViewModel(confidence, level);
    }
}
